export default "__VITE_ASSET__BASwJ6Pj__"